import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  stagger?: boolean;
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up',
  stagger = false
}: FadeInProps) {
  const directions = {
    up: {
      y: 40,
      x: 0
    },
    down: {
      y: -40,
      x: 0
    },
    left: {
      x: 40,
      y: 0
    },
    right: {
      x: -40,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  const containerVariants = {
    hidden: {
      opacity: 0,
      filter: 'blur(8px)',
      ...directions[direction]
    },
    visible: {
      opacity: 1,
      filter: 'blur(0px)',
      x: 0,
      y: 0,
      transition: {
        duration: 1.2,
        delay,
        ease: [0.21, 0.47, 0.32, 0.98],
        when: stagger ? 'beforeChildren' : 'all',
        staggerChildren: stagger ? 0.2 : 0
      }
    }
  };
  return <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-50px'
  }} className={className} data-id="element-311">
      {children}
    </motion.div>;
}